angular.module('zc.projects')

.directive 'zcCartPriceConfirm', ($filter, BaseProjectConfirm) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.initialization.cartPriceConfirm.cartAmount'), ['cart_price']
  confirm.createDirective confirm.requestRecentCartSessions



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/initialization/cart_price_confirm.controller.coffee